import notify from '@/migration/notification';
import { getSaleId } from '@/utils';

export default function submitComment(props) {
  return async (immutableValues) => {
    const values = immutableValues.toJS();
    const {
      updateCommentErrorMessage,
      getSaleCommentsBeforePagination,
      postSaleCommentBefore,
      sales: {
        commentsBefore: { current },
      },
      reset,
      change,
      takeTemporaryComment,
    } = props;

    updateCommentErrorMessage(false);
    if (!values.message) {
      updateCommentErrorMessage(true);
      return;
    }
    try {
      const saleId = getSaleId();

      const result = await postSaleCommentBefore(saleId, values.message);

      // 禁止ワードによるエラーか判断
      const errors = result.value?.response?.data?.errors;
      if (errors) {
        if (errors.some((f) => f.message === 'contain ban words')) {
          throw new Error('禁止ワードが含まれています。');
        }
      }

      // eslint-disable-next-line
      if (!result.value.data.hasOwnProperty('id')) {
        throw new Error(result.value.message);
      }
      reset();

      await getSaleCommentsBeforePagination(saleId, {
        limit: 5,
        page: current,
      });

      change('message', '');
      takeTemporaryComment('');
    } catch (error) {
      switch (error.message) {
        case '禁止ワードが含まれています。':
          notify('禁止ワードが含まれています。', 'error', undefined, 5);
          break;
        case 'contain ban words':
          notify('不適切な表現が含まれています。', 'error', undefined, 5);
          break;

        default:
          notify(
            '書き込みに失敗しました。しばらく時間をおいて再度お試しください。',
            'error',
            undefined,
            5
          );
          break;
      }
    }
  };
}
